export const headerDemo ={
    "Content-Type": "application/json;",
    'Cache-Control': 'no-cache',
    "api-version": "1.0",
    // "Authorization": "Bearer "+ localStorage.token,
    'userkey': localStorage.getItem('userkey'),
    'userid': localStorage.getItem('Id'),
    'appid': 'back',
}


// WEBPACK FOOTER //
// ./src/api/editHeader.js